import { render, staticRenderFns } from "./address-edit.vue?vue&type=template&id=8b45ff34&"
import script from "./address-edit.vue?vue&type=script&lang=js&"
export * from "./address-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports